var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallRinging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.454 24.232v-.01l-4.83-2.06a3.474 3.474 0 0 0-1.83 2.07 11.945 11.945 0 0 1-8.08-8.07 3.5 3.5 0 0 0 2.08-1.82l-2.07-4.85a.01.01 0 0 0-.01-.01 3.511 3.511 0 0 0-4.59 3.34 15.991 15.991 0 0 0 15.57 15.99c.14.01.29.01.43.01s.29 0 .43-.01a3.5 3.5 0 0 0 3.08-3.48A3.3 3.3 0 0 0 22.454 24.232zM16.851 15.709a.5.5 0 0 0 .357-.15L20.2 12.507a.5.5 0 0 0-.715-.7l-2.987 3.051a.5.5 0 0 0 .357.85zM17.313 18.12a.5.5 0 0 0 .5.5h4.051a.5.5 0 0 0 0-1H17.813A.5.5 0 0 0 17.313 18.12zM13.838 14.722a.5.5 0 0 0 .5-.5V10.171a.5.5 0 0 0-1 0v4.051A.5.5 0 0 0 13.838 14.722z",
    "data-name": "Layer 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRinging);
export default __webpack_public_path__ + "static/media/call-ringing.88950744.svg";
export { ForwardRef as ReactComponent };